if (typeof document !== 'undefined' && process.env.NODE_ENV !== 'test' && !document.head.querySelector("style[data-wp-hash='c46e8cb841']")) {
	const style = document.createElement("style");
	style.setAttribute("data-wp-hash", "c46e8cb841");
	style.appendChild(document.createTextNode("@layer wp-ui-utilities, wp-ui-components, wp-ui-compositions, wp-ui-overrides;@layer wp-ui-components{.f37b9e2e191ebd66__visually-hidden{word-wrap:normal;border:0;clip-path:inset(50%);height:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;width:1px;word-break:normal}}"));
	document.head.appendChild(style);
}
export default {"visually-hidden":"f37b9e2e191ebd66__visually-hidden"};
